var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinDesktopImmersiveReader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none",
  viewBox: "0 0 14 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M13.97 0h-3.95C8.81 0 7.73.55 6.99 1.4 6.25.55 5.18 0 3.96 0H.03S0 .01 0 .03v10.94s.01.03.03.03h3.85c.85 0 1.61.54 1.89 1.34l.23.64s.01.02.02.02h1.97s.02 0 .02-.02l.23-.64c.28-.8 1.04-1.34 1.89-1.34h3.85s.03-.01.03-.03V.03S14 0 13.98 0zM12 9h-1.88c-.77 0-1.5.22-2.12.61V4.03C8 2.91 8.91 2 10.03 2H12zM2 2h1.97C5.09 2 6 2.91 6 4.03v5.58C5.38 9.22 4.65 9 3.88 9H2z"
})));
export default SvgLinkedinDesktopImmersiveReader;